import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCommentOutline24 = function SvgCommentOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.69 18.523.148-.443-.245-.398A10.825 10.825 0 0 1 1 12C1 5.935 5.935 1 12 1s11 4.935 11 11-4.935 11-11 11c-1.912 0-3.786-.497-5.433-1.438l-.365-.21-.405.116-4.523 1.291 1.416-4.236zM.025 23.342a.503.503 0 0 0 .613.639l5.433-1.551a11.952 11.952 0 0 0 5.93 1.57C18.616 24 24 18.617 24 12S18.617 0 12 0 0 5.383 0 12c0 2.212.602 4.353 1.741 6.206L.025 23.342zM6.5 9h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm11 3h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm-11 3h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z",
    fill: "currentColor"
  })));
};

var CommentOutline24Svg = SvgCommentOutline24;

export { CommentOutline24Svg as default };
//# sourceMappingURL=CommentOutline24.svg.js.map
